import { useStore } from 'effector-react'
import * as React from 'react'

import {
  $currencies,
  $inHold,
  $wallet,
  getWallet,
  walletMounted,
} from './model'
export const useWallet = () => {
  const wallet = useStore($wallet)
  const currencies = useStore($currencies)
  const inHold = useStore($inHold)
  const loadingWallet = useStore(getWallet.pending)

  React.useEffect(() => {
    walletMounted()
  }, [])

  return { wallet, currencies, loadingWallet, inHold }
}
